interface IConfig {
  apiUrl: string;
  apiPrefix: string;
  recaptchaSiteKey: string;
}

declare global {
  interface Window {
    APP_CONFIG: IConfig;
  }
}

export default window.APP_CONFIG;
